;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.textFitting = (function () {
    function maxFontSize () {
      var ww = $(window).width()
      if (ww < 400) { return 36 }
      if (ww < 620) { return 48 }
      return 96
    }

    function maxFontSizeLarge () {
      var ww = $(window).width()
      // if (ww < 400) { return 42 }
      if (ww < 620) { return 48 }
      return 136
    }

    var fitLarge = window._.debounce(function () {
      // console.log('fitting large text...')
      var max = maxFontSizeLarge()
      var sel = '.js-largetextfit'
      $(sel).fitText(0.3) // seems to prime things
      window.fitty(sel, { minSize: 36, maxSize: max }) // once maximizes the text

      // remove the listener on fittext since it blows things up
      $(window).off('resize.fittext orientationchange.fittext')
    }, 100)

    var fit = window._.debounce(function () {
      // console.log('fitting text...')
      var max = maxFontSize()
      var sel = '.js-textfit'
      $(sel).fitText(0.5) // seems to prime things
      window.fitty(sel, { minSize: 36, maxSize: max }) // once maximizes the text

      // remove the listener on fittext since it blows things up
      $(window).off('resize.fittext orientationchange.fittext')
    }, 100)

    function init () {
      if (!window.fitty) { return }
      var $regular = $('.js-textfit')
      if ($regular.length) {
        fit()
        $(window).on('resize.eah-textfit orientationchange.eah-textfit', fit)
      }
      var $large = $('.js-largetextfit')
      if ($large.length) {
        fitLarge()
        $(window).on('resize.eah-largetextfit orientationchange.eah-largetextfit', fitLarge)
      }
    }

    // console.log('fitting text module...')
    return {
      init: init
    }
  }())

  $(window).on('load', eah.textFitting.init)
}(jQuery, window))
